var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtRibbon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 8)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#797F9D",
    d: "M8.902 48.79 2.135 68.314l12.742-4.563 7.23 11.189 7.075-19.854"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797F9D",
    d: "M27.114 52.197 37.457 84l7.186-11.079L57 77.672 46.8 47.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78 51.921c.88.827 1.97 1.753 3.268 2.668 4.39 3.065 9.903 5.027 15.625 5.346 4.534.254 9.2-.54 13.524-2.645 1.893-.926 4.908-2.679 8.022-5.964l-2.872-6.757-14.8-.122-20.181-.165",
    fill: "#3C435B",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E09D35",
    cx: 28.247,
    cy: 28.298,
    rx: 28.247,
    ry: 28.298
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E8B85C",
    cx: 28.379,
    cy: 28.209,
    rx: 24.66,
    ry: 24.704
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.93 13.162 2.718 7.53a1.995 1.995 0 0 0 1.86 1.311h8.308c1.97 0 2.74 2.569 1.078 3.649l-6.349 4.145a1.997 1.997 0 0 0-.781 2.337l2.509 6.945c.649 1.797-1.354 3.384-2.95 2.337l-7.196-4.707a1.983 1.983 0 0 0-2.168 0l-7.196 4.707c-1.596 1.047-3.598-.551-2.95-2.337l2.51-6.945c.308-.871 0-1.841-.781-2.337l-6.35-4.145c-1.65-1.08-.891-3.649 1.079-3.649h8.308c.836 0 1.584-.529 1.86-1.312l2.717-7.529c.627-1.753 3.103-1.753 3.73 0h.045z",
    fill: "#F3D9A2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m27.41 60.046 1.178-3.352 1.067 3.319"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtRibbon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-ribbon.537155e26e4c3ec917ade8563b064d82.svg";